module.exports = __webpack_public_path__ + "img/pic_bt_tw.354cc2e4.png";